interface RZPPayload {
    "error[code]": string;
    "error[description]": string;
    "error[source]": string;
    "error[step]": string;
    "error[reason]": string;
    "error[metadata]": {
        payment_id: string | null;
        order_id: string;
    };
    ISIN: string;
    userId?: string;
}

export interface RazorpayPaymentDetails {
    razorpay_payment_id: string;
    razorpay_order_id: string;
    razorpay_signature: string;
    error?: PaymentErrorDetails;
}

interface PaymentErrorMetadata {
    payment_id: string;
    order_id: string;
}

interface PaymentErrorDetails {
    code: string;
    description: string;
    source: string;
    step: string;
    reason: string;
    metadata: PaymentErrorMetadata;
}

export interface RazorpayPaymentError {
    error?: PaymentErrorDetails;
}
  

export const statusFailedRZP = async (isin: string | null, orderId: string) => {
    try {
        const url = `${process.env.API_BASE_URL}/unlisted/equities/isins/${isin}/transactions/${orderId}`;
        const payload = {
            status: "failed",
        };
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-partner": "orobonds:default",
            },
            body: JSON.stringify(payload),
            credentials: "include",
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        return result;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err;
    }
};

export const RZPModalDismiss = async (isin: string, payload: RZPPayload) => {
    try {
        const url = `${process.env.API_BASE_URL}/unlisted/equities/pg/callback/${isin}`;
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-partner": "orobonds:default",
            },
            body: JSON.stringify(payload),
            credentials: "include",
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        return result;
    } catch (err) {
        console.error("Error posting data:", err);
        return err;
    }
};

export const RZPCallback = async (isin: string, payload: RazorpayPaymentDetails) => {
    try {
        const url = `${process.env.API_BASE_URL}/unlisted/equities/pg/callback/${isin}`;
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-partner": "orobonds:default",
            },
            body: JSON.stringify(payload),
            credentials: "include",
            // Let browser handle redirects automatically
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        return result;
    } catch (err) {
        console.error("Error posting data:", err);
        return err;
    }
};

// export const advisoryRZPFailed = async (isin: string, payload: RazorpayPaymentDetails) => {
//     try {
//         const url = `/unlisted/equities/pg/callback/${isin}`;
//         const response = await fetch(url, {
//             method: "POST",
//             headers: {
//                 "Content-Type": "application/json",
//                 // "X-partner": "orobonds:default",
//             },
//             body: JSON.stringify(payload),
//             credentials: "include",
//         });
//         if (!response.ok) {
//             throw new Error(`HTTP error! status: ${response.status}`);
//         }
//         const result = await response.json();
//         return result;
//     } catch (err) {
//         console.error("Error fetching data:", err);
//         return err;
//     }
// };
